import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/dripping-springs")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Dripping Springs, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Dripping Springs & Hays County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Dripping Springs, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Dripping Springs and Hays County.",
      keywords: "awnings Dripping Springs, awning company Dripping Springs, custom awnings Dripping Springs, sail shades Dripping Springs, patio covers Dripping Springs, pergola covers Dripping Springs, metal awnings Dripping Springs, canvas awnings Dripping Springs, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Dripping Springs", "Hays County"),
  }),
  component: () => <CityHomePage city="Dripping Springs" region="Hays County" />,
});
